routesConfig.$inject = ['$stateProvider'];

function routesConfig($stateProvider){
  $stateProvider
    .state('home.pqrsList', {
      url: "/pqrs/listado",
      template: `<pqrs-list sh-ctrl="shCtrl"></pqrs-list>`
    });
}

export default routesConfig;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/pqrs/pqrs-list/pqrs-list.config.js
 **/